// Gasto Servicio por Unidad — total gastado en servicios por auto en el
// periodo. Solo cuenta servicios con status='paid' (los 'denied' se rechazaron
// y no representan gasto real).
import supabase from "../../../supabase-client";

const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const serviceCostPerCarReport = {
  id: "service-cost-per-car",
  title: "Gasto Servicio por Unidad",
  description: "Total gastado en servicios pagados por auto en el periodo.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  summary: [
    { type: "count", label: "Autos con Gasto" },
    { type: "sum", label: "Gasto Total", valueKey: "total_cost", valueFormat: fmtMoney },
    { type: "sum", label: "Mantenimiento", valueKey: "mantenimiento", valueFormat: fmtMoney },
    { type: "sum", label: "Siniestros", valueKey: "siniestros", valueFormat: fmtMoney },
    { type: "sum", label: "Traslado / Gestoria", valueKey: "traslado_gestoria", valueFormat: fmtMoney },
  ],
  columns: [
    { key: "plate", label: "Placa" },
    { key: "model", label: "Modelo", width: 220, truncate: true },
    { key: "branch", label: "Sucursal" },
    { key: "service_count", label: "# Servicios", exportType: "integer" },
    { key: "mantenimiento", label: "Mantenimiento", format: fmtMoney, exportType: "currency" },
    { key: "siniestros", label: "Siniestros", format: fmtMoney, exportType: "currency" },
    { key: "traslado_gestoria", label: "Traslado / Gestoria", format: fmtMoney, exportType: "currency" },
    { key: "sin_categoria", label: "Sin categoría", format: fmtMoney, exportType: "currency" },
    { key: "total_cost", label: "Gasto Total", format: fmtMoney, exportType: "currency" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_service_cost_per_car", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
